export default __webpack_public_path__ + "static/media/piper-castlerock.7bdfc1d0.jpg";